import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInbox2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM15.874 14H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V14H8.12602C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14ZM14 13C14 12.4477 14.4477 12 15 12H19V6C19 5.44772 18.5523 5 18 5H6C5.44772 5 5 5.44772 5 6V12H9C9.55228 12 10 12.4477 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13Z"
	})
});
export default SvgInbox2Line;
